<div class="product-phishing">
  <div class="products-phishing__container">
    <section class="products-phishing__section-hero">
      <app-hero-section [routerButton]="routerHeroButton" [logoPath]="logoPath" [isProductLogo]="isProductLogo" [buttonText]="buttonText" [header]="header" [hasBtn]="hasBtn" [imagePath]="imagePath"
        [description]="description" [joinChat]="joinChat">
      </app-hero-section>
    </section>

    <section class="products-phishing__section-analysis">
      <h2 l10nTranslate>Holistic Approach To Manage Human Risk</h2>
      <img *ngIf="currentLanguage == 'en'" src="../../../../assets/svg/Frame 480969248.svg" />
      <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Frame48096928ar.png" />
    </section>

    <section class="products-phishing__section-micro-Learning">
      <div>
        <h2 l10nTranslate>Access Large Awareness Content Library</h2>
        <div class="product-grc-header" l10nTranslate>
          With Micro Learning Approach (1-3 Minutes)
        </div>
      </div>
      <div class="product-phishing-micro-Learning__cards">
        <ng-container *ngFor="let item of sectionMicroLearning">
          <div class="products-phishing-micro-Learning__container-card">
            <img src="{{ item?.imagePath }}" />
            <div class="products-phishing-micro-learning-description" l10nTranslate>
              {{ item?.title }}
            </div>
          </div>
        </ng-container>
      </div>
      <div class="products-phishing__btn-holder">
        <button class="products-phishing__btn" routerLink="/awareness-posters" l10nTranslate>Get Free Awareness Posters</button>
      </div>
    </section>

    <section class="products-phishing__section-update-content">
      <app-list-with-image [items]="items" [tileList]="tileList" [imgListPath]="imgListPath"
        [descriptionList]="descriptionList" [routerListButton]="routerListButton" [buttonListText]="buttonListText">
      </app-list-with-image>
    </section>

    <section class="products-phishing__section-high-automation">
      <div class="products-phishing__section-high-automation-info">
        <div class="products-phishing__section-high-automation-title" l10nTranslate>Awareness Content Covers a Wide Range of Domains
        </div>
        <div class="products-phishing__section-high-automation-description" l10nTranslate>Align your awareness program with
          regulations by covering the required domains</div>
      </div>
      <div class="products-phishing__section-high-automation-row">
        <div class="products-phishing__section-high-automation-card">
          <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Frame 39786.png" />
          <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Frame 397863.png" />
        </div>
        <div *ngIf="!commonService.isMobile" class="products-phishing__section-high-automation-card">
          <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/Group 39784.png" />
          <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/Group 397849.png" />
        </div>
      </div>
      <div class="products-phishing__section-high-automation-in-compliance-with">
        <div class="products-phishing__section-high-automation-in-compliance-with-holder">
          <div class="products-phishing__section-high-automation-in-compliance-with-item">
            <div l10nTranslate>In compliance with</div>
          </div>
          <div class="products-phishing__section-high-automation-in-compliance-with-item">
            <img src="../../../../assets/images/tickcircle2.png">
            <div>NCA</div>
          </div>
          <div class="products-phishing__section-high-automation-in-compliance-with-item">
            <img src="../../../../assets/images/tickcircle2.png">
            <div>SAMA</div>
          </div>
          <div class="products-phishing__section-high-automation-in-compliance-with-item">
            <img src="../../../../assets/images/tickcircle2.png">
            <div>CST</div>
          </div>
          <div class="products-phishing__section-high-automation-in-compliance-with-item">
            <img src="../../../../assets/images/tickcircle2.png">
            <div>Aramco</div>
          </div>
          <div class="products-phishing__section-high-automation-in-compliance-with-item">
            <img src="../../../../assets/images/tickcircle2.png">
            <div>ISO</div>
          </div>
        </div>
      </div>

    </section>

    <section class="">
      <app-image-with-text [imageText]="imageText" [routerLink]="routerLink" [imageUrl]="imageUrl"
        [buttonText]="buttonImgText" [routerButton]="routerButton" [imageTextPath]="imageTextPath"
        [isProductsPage]="isProductsPage" [subImgUrl]="subImgUrl2" [subTitle]="subTitle2"
        [type]="'Products'"></app-image-with-text>
    </section>

    <section class="products-phishing__section-measure-employee">
      <div class="products-phishing__measure-employee-container">
        <div class="products-phishing__measure-employee-info-holder">
          <h4 l10nTranslate>Measure Employees Cyber Knowledge And Identify Their Weaknesses</h4>
          <h6 l10nTranslate>Auto-enroll users onto personalized training courses</h6>
        </div>
        <div class="products-phishing__measure-employee-cards-holder">
          <div class="products-phishing__measure-employee-card">
            <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/svg/Frame969.svg" style="margin-top: -1rem;" />
            <img *ngIf="currentLanguage == 'en'" src="../../../../assets/svg/Frame999.svg" style="margin-top: -1rem;" />
            <h6 l10nTranslate>Assess2</h6>
            <p l10nTranslate>Assess Knowledge And Behavior</p>
          </div>
          <span class="products-phishing__measure-employee-arrow">&rarr;</span>
          <div class="products-phishing__measure-employee-card">
            <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/svg/Frame989.svg" />
            <img *ngIf="currentLanguage == 'en'" src="../../../../assets/svg/Frame299.svg" />
            <h6 l10nTranslate>Identify</h6>
            <p l10nTranslate>Enhancement Areas</p>
          </div>
          <span class="products-phishing__measure-employee-arrow">&rarr;</span>
          <div class="products-phishing__measure-employee-card">
            <img src="../../../../assets/svg/Target33.svg" style="margin-top: 3rem;" />
            <h6 l10nTranslate>Launch</h6>
            <p l10nTranslate>Personalized Training</p>
          </div>
        </div>
        <div class="products-phishing__btn-holder">
          <button class="products-phishing__btn" l10nTranslate>Request a demo2</button>
        </div>
      </div>
      <!-- <app-list-with-image [items]="employeeItems" [tileList]="employeeItemsTileList"
        [descriptionList]="employeeDescriptionList" [imgListPath]="employeeImgListPath"
        [routerListButton]="employeeRouterListButton" [buttonListText]="employeeButtonListText">
      </app-list-with-image> -->
    </section>

    <section>

    </section>
    <section class="products__phishing-awareness-methodology">

      <div class="products__phishing-awareness-methodology-holder">
        <h2 l10nTranslate>Best Practice Awareness Methodology</h2>
        <div class="products__phishing-awareness-methodology-description" l10nTranslate>to get the best ROI on your
          security awareness program</div>
        <app-side-accordion [items]="accordionItems"></app-side-accordion>

      </div>
    </section>


    <app-image-with-text [imageUrl]="banner.imageUrl" [imageText]="banner.imageText" [buttonText]="banner.buttonText"
      [routerButton]="banner.routerButton" [subImgUrl]="subImgUrl" [subTitle]="subTitle"
      [isProductsPage]="isProductsPage" [type]="'Services'">
    </app-image-with-text>


    <section class="products__phishing-reports">
      <div class="products__phishing-reports__text">
        <h2 l10nTranslate>Generate Detailed Reports</h2>
        <h6 *ngIf="currentLanguage == 'en'" l10nTranslate>Oversee your awareness program with detailed reports and
          metrics</h6>
      </div>
      <div>
        <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/reportEn.png" />
        <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/reportAr.png" />
      </div>
    </section>


    <app-feature-section class="products-phishing__section-feature">
    </app-feature-section>


    <section class="products__phishing-steps-awareness-program">
      <div class="products__phishingsteps-awareness-program-text">
        <h2 l10nTranslate>You Are Five Steps Away</h2>
        <div l10nTranslate>To automate your awareness program</div>
      </div>
      <img *ngIf="currentLanguage == 'en'" src="../../../../assets/svg/five-step.svg" />
      <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/svg/five-step-ar.svg" />
    </section>
  </div>
</div>